import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { authAPI } from '../../services/api';
import './LoginPage.css';

interface LoginPageProps {
    onLogin: (success: boolean) => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLogin }) => {
    const navigate = useNavigate();
    const [credentials, setCredentials] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await authAPI.login(credentials);

            if (response.data.token) {
                localStorage.setItem('admin_token', response.data.token);
                localStorage.setItem('isAdminAuthenticated', 'true');
                localStorage.setItem('adminUser', JSON.stringify({
                    email: credentials.email,
                    role: 'admin'
                }));
                onLogin(true);
                navigate('/admin');
            }
        } catch (err: any) {
            console.error('Login error:', err);
            setError(err.response?.data?.error || 'Неверный email или пароль');
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-background">
                <div className="bg-shape shape-1"></div>
                <div className="bg-shape shape-2"></div>
                <div className="bg-shape shape-3"></div>
            </div>

            <motion.div
                className="login-container"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <div className="login-header">
                    <div className="login-logo">
                        <span className="logo-icon">✈️</span>
                        <span className="logo-text">FlyMeal</span>
                    </div>
                    <h1>Admin Panel</h1>
                    <p>Sign in to manage your airline catering services</p>
                </div>

                <form className="login-form" onSubmit={handleSubmit}>
                    {error && (
                        <motion.div
                            className="error-message"
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                        >
                            <span className="error-icon">⚠️</span>
                            {error}
                        </motion.div>
                    )}

                    <div className="form-group">
                        <label htmlFor="email">Email Address</label>
                        <div className="input-wrapper">
                            <span className="input-icon">📧</span>
                            <input
                                type="email"
                                id="email"
                                value={credentials.email}
                                onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
                                placeholder="Enter your email"
                                required
                                autoComplete="email"
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <div className="input-wrapper">
                            <span className="input-icon">🔒</span>
                            <input
                                type="password"
                                id="password"
                                value={credentials.password}
                                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                                placeholder="Enter your password"
                                required
                                autoComplete="current-password"
                            />
                        </div>
                    </div>

                    <div className="form-options">
                        <label className="remember-me">
                            <input type="checkbox" />
                            <span>Remember me</span>
                        </label>
                        <a href="#forgot" className="forgot-link">Forgot password?</a>
                    </div>

                    <button type="submit" className="login-btn" disabled={loading}>
                        {loading ? (
                            <span className="btn-loading">
                                <span className="spinner-small"></span>
                                Signing in...
                            </span>
                        ) : (
                            'Sign In'
                        )}
                    </button>
                </form>

                <div className="demo-credentials">
                    <p className="demo-title">Учетные данные:</p>
                    <p><strong>Email:</strong> admin@fly.com</p>
                    <p><strong>Пароль:</strong> admin123</p>
                </div>

                <div className="login-footer">
                    <button onClick={() => navigate('/')} className="back-home">
                        ← Back to Home
                    </button>
                </div>
            </motion.div>
        </div>
    );
};

export default LoginPage;
